import React, { useEffect } from 'react';

import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid2';
import { NO_VALUE } from '../Graphs/constants';
import Radio from '@mui/material/Radio';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  label: {
    margin: 0,
  },
  control: {
    color: 'white',
    '&.Mui-checked': {
      ...theme.palette.accentText,
    },
  },
  radioRow: {
    width: '100%',
    justifyContent: 'space-between',
    margin: 0,
  },
  disabled: {
    color: 'rgba(0, 0, 0, 0.26)',
  },
}));

// item - the radio button item ex: { isDisabled: (itemIsDisabledParams) => {}, label: 'Satellite', value: 'satellite' }
// styles - styles to override
export default ({
  handleToggle,
  value,
  item = {},
  itemIsDisabledParams = {},
  labelPlacement = 'end',
  styles = {},
}) => {
  const classes = useStyles();

  useEffect(() => {
    // if item is disabled, and the value is selected, then deselect it
    if (item.isDisabled && item.isDisabled(itemIsDisabledParams) && value === item.value) {
      handleToggle({ target: { value: NO_VALUE } });
    }
  }, [item.isDisabled && item.isDisabled(itemIsDisabledParams)]);

  return (
    <Tooltip title={item.tooltip || ''}>
      {item.options ? (
        <Grid
          className={clsx({
            [classes.radioRow]: true,
            [classes.disabled]: item.isDisabled && item.isDisabled(itemIsDisabledParams),
          })}
          container
          direction="row"
          sx={{
            alignItems: 'center',
          }}
        >
          <Typography style={{ fontWeight: 'bold' }}>{item.label}</Typography>
          <Grid>
            {item.options.map((option) => (
              <FormControlLabel
                key={`radio-item-${item.label}-option-${option.label}`}
                style={{ margin: 0 }}
                onClick={(e) => e.preventDefault()}
                value={option.value}
                control={
                  <Radio
                    onClick={(event) => {
                      event.target.value = option.value;
                      handleToggle(event);
                    }}
                    disabled={
                      (item.isDisabled && item.isDisabled(itemIsDisabledParams)) ||
                      (option.isDisabled && option.isDisabled(itemIsDisabledParams))
                    }
                    className={clsx({
                      [classes.control]: true,
                      [styles.radioItemControl]: !!styles.radioItemControl,
                    })}
                  />
                }
                label={option.label}
                labelPlacement={labelPlacement}
              />
            ))}
          </Grid>
        </Grid>
      ) : (
        <FormControlLabel
          className={clsx({
            [classes.label]: true,
            [styles.radioItemLabel]: !!styles.radioItemLabel,
          })}
          // Without this, the onClick event will be triggered twice
          onClick={(e) => e.preventDefault()}
          value={item.value}
          control={
            <Radio
              onClick={(event) => {
                // For some reason the event.target.value is undefined
                // I've set it instead of passing it separately to avoid breaking other components
                event.target.value = item.value;
                handleToggle(event);
              }}
              disabled={(item.isDisabled && item.isDisabled(itemIsDisabledParams)) || false}
              className={clsx({
                [classes.control]: true,
                [styles.radioItemControl]: !!styles.radioItemControl,
              })}
            />
          }
          label={item.label}
          labelPlacement={labelPlacement}
        />
      )}
    </Tooltip>
  );
};
